module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      R.L. Stine\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" R.L. Stine is the creator of the bestselling Goosebumps series, which has more than 400 million copies in print worldwide and celebrated 25 years in 2017. Goosebumps is one of the bestselling children's series of all-time and inspired a popular television show, as well as a feature film starring Jack Black that opened at #1 at the box office. His other popular children's books include the series Fear Street, Mostly Ghostly, The Nightmare Room, and Rotten School, and his  picture books, with Marc Brown, "), _c('I', [_vm._v("The Little Shop of Monsters")]), _vm._v(" and "), _c('I', [_vm._v("Mary McScary")]), _vm._v(". R.L. Stine lives in New York City. You can connect with him on Twitter at @RL_Stine or Facebook: facebook.com/rlstine. For more information, visit rlstine.com and scholastic.com/goosebumps. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19ENzTz/tc-custom/9780545820776.jpg?1704252159515",
      "alt": "This image is the cover for the book Werewolf Skin, Goosebumps"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Werewolf Skin, Goosebumps\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v(" From the "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling Goosebumps series, ignoring his family’s warnings, a boy goes into the woods after dark and encounters werewolves.")]), _c('br'), _c('br'), _vm._v("Picture this—Alex Hunter, photography freak, hanging out in Wolf Creek. Who lives in the small town of Wolf Creek? Alex’s uncle Colin and aunt Marta. They’re professional photographers. Uncle Colin and Aunt Marta are pretty cool. They only have two requests. Don’t go into the woods late at night. And stay away from the creepy house next door. Poor Alex. He just wanted to take a couple of pictures. But now he’s about to find out the secret of Wolf Creek. Late one night. When the moon is full . . . "), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Scholastic\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0